<div class="autosearch">
	<div class="autosearch__container" [class.focused]="isFocused">
		<div class="autosearch__container__form">
			<label
				for="{{inputId}}"
				class="autosearch__container__form-label"
				[class.transformed]="isFocused"
			>
				Your Pet's Breed
			</label>
			<input
				class="autosearch__container__form-input"
				id="{{inputId}}"
				autocomplete="off"
				aria-autocomplete="none"
				[disabled]="disabled"
				type="text"
				[(ngModel)]="selectedBreed"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(input)="onInputChange($event)"
			/>
			<button
				class="autosearch__container__form-icon"
				[class.close]="selectedBreed"
				[disabled]="disabled"
				(click)="closeMenu(true)"
				type="button"
				tabindex="0"
				aria-label="Toggle to open and close the expandable list"
			>
				<img
					*ngIf="!selectedBreed"
					src="../../../assets/icons/magnifying-glass.svg"
					alt="Open the expandable list"
				/>
				<img
					*ngIf="selectedBreed"
					src="../../../assets/icons/close-x.svg"
					alt="Close the expandable list"
				/>
			</button>
		</div>
		<ul
			*ngIf="toggleMenu"
			class="autosearch__container__list"
			tabindex="0"
			aria-haspopup="listbox"
		>
			<li
				*ngFor="let breed of breeds; let i = index"
				slot="option"
				id="breedListOption{{ breed.id }}"
				attr.data-quat="input_breedOption{{ i }}"
				(click)="selectOption(breed)"
			>
				{{ breed.name }}
			</li>
		</ul>
	</div>
</div>
